module.exports = __webpack_public_path__ + "static/media/hyundai.5579748c.svg";